import { useState } from 'react';

import PhoneInput from '../../components/PhoneInput/PhoneInput';
import { useToast } from '../../contexts/ToastContext';
import { useUsuarioService } from '../../services/usuarioServices';
import { createEmptyPhoneModel, toPhonePayload } from '../../utils/phoneCountries';
import styles from './loginpage.module.css';

const GENERIC_SUCCESS = 'Se os dados conferirem com o cadastro, o código será enviado.';

function RecuperarSenhaUsuarioPage() {
  const { showToast } = useToast();
  const { gerarCodigoRecuperacaoUsuario } = useUsuarioService();
  const [telefone, setTelefone] = useState(() => createEmptyPhoneModel());
  const [email, setEmail] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [telefoneErro, setTelefoneErro] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErro('');
    setTelefoneErro('');

    if (!telefone.isValid) {
      const message = 'Telefone inválido para o país informado.';
      setTelefoneErro(message);
      showToast(message, 3000, 'error');
      return;
    }

    setCarregando(true);
    try {
      const resposta = await gerarCodigoRecuperacaoUsuario({
        ...toPhonePayload('telefone', telefone),
        email: email.trim().toLowerCase(),
      });

      if (resposta.success) {
        showToast(resposta.message || GENERIC_SUCCESS, 4000, 'success');
      } else {
        const message = resposta.status === 503
          ? 'O serviço de recuperação está temporariamente indisponível. Tente novamente mais tarde.'
          : (resposta.message || 'Não foi possível concluir a solicitação.');
        setErro(message);
        showToast(message, 4000, 'error');
      }
    } catch {
      const message = 'Erro de rede ou servidor.';
      setErro(message);
      showToast(message, 3000, 'error');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Recuperar Senha (Administrador)</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <p>Informe seu telefone e e-mail cadastrados.</p>
        <PhoneInput
          value={telefone}
          onChange={setTelefone}
          label="Telefone"
          error={telefoneErro}
          disabled={carregando}
          required
        />
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel} htmlFor="recovery-admin-email">E-mail</label>
          <input
            id="recovery-admin-email"
            type="email"
            placeholder="seuemail@email.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className={styles.input}
            autoComplete="email"
            required
          />
        </div>
        <button type="submit" className={styles.button} disabled={carregando}>
          {carregando ? 'Enviando código...' : 'Enviar Código'}
        </button>
        {erro && <p className={styles.error}>{erro}</p>}
      </form>
    </div>
  );
}

export default RecuperarSenhaUsuarioPage;
